export default __webpack_public_path__ + "static/Economic Model Update - French-bf1fb185a179131ada823ce6ee763417.pdf";